import React, { memo, useEffect, useRef } from "react";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import { errorHandler } from "../../helper-methods";
import { FRONTEND_CREATOR_BASE_URL } from "../../config";

export const HostStreaming = ({ eventStreamingData }) => {
  const streamingDivRef = useRef();
  const zpRef = useRef({ current: null });

  const sharedLinks = [
    {
      name: "Join as co-host",
      url: `${FRONTEND_CREATOR_BASE_URL}/login?redirectTo=/live-event-streaming/${eventStreamingData?.eventId}`,
    },
    {
      name: "Room ID",
      url: eventStreamingData?.roomId,
    },
  ];

  // start the call
  const _startMeeting = async () => {
    try {
      // Host / Cohost / Audience
      const role = ZegoUIKitPrebuilt[eventStreamingData?.userRole || "Host"];

      const kitToken = ZegoUIKitPrebuilt.generateKitTokenForProduction(
        eventStreamingData?.appId,
        eventStreamingData?.token,
        eventStreamingData?.roomId,
        eventStreamingData?.userId,
        eventStreamingData?.userName
      );

      // Create instance object from Kit Token.
      zpRef.current = ZegoUIKitPrebuilt.create(kitToken);

      // start the call
      zpRef.current.joinRoom({
        container: streamingDivRef.current,
        showTextChat: false,
        showPreJoinView: false,
        turnOnCameraWhenJoining: false,
        showRoomTimer: true,
        showRemoveUserButton: true,
        showRoomDetailsButton: true,
        scenario: {
          mode: ZegoUIKitPrebuilt.LiveStreaming,
          config: {
            role,
          },
        },
        sharedLinks,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const _stopMeeting = () => {
    try {
      zpRef.current.destroy();
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    _startMeeting();

    return () => {
      _stopMeeting();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div ref={streamingDivRef} className="myCallContainer" />
    </>
  );
};

export default memo(HostStreaming);
